import React from 'react';
import { motion } from 'framer-motion';

export function WarrantyStatementSection() {
  return (
    <section className="bg-gradient-to-r from-teal-50 to-emerald-50 py-16 md:py-24 px-4 md:px-6 text-center relative overflow-hidden">
      {/* Background SVG elements */}
      <div className="absolute inset-0 overflow-hidden opacity-20">
        <svg className="absolute -top-12 -left-12 text-teal-400 w-64 h-64" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M44.9,-76.2C55.9,-68,61.2,-51.1,68.1,-35.8C75,-20.5,83.5,-7,83.8,6.8C84.1,20.6,76.3,34.7,66.2,45.9C56.2,57,43.8,65.2,30.8,69.7C17.8,74.2,4.3,74.9,-8.9,72.4C-22.1,69.9,-35,64.1,-46.5,55.6C-58,47.1,-68.2,35.9,-74.8,22C-81.4,8.1,-84.5,-7.5,-80.1,-20.8C-75.8,-34.1,-64,-45.1,-50.8,-52.5C-37.6,-59.9,-23,-63.8,-7.8,-72.3C7.3,-80.8,33.9,-84.4,44.9,-76.2Z" transform="translate(100 100)" />
        </svg>
        <svg className="absolute -bottom-24 -right-24 text-green-400 w-96 h-96" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="currentColor" d="M48.2,-75.2C60.3,-68.2,66.8,-49.8,72.5,-32.6C78.2,-15.4,83,-0.5,81.4,14.2C79.8,28.9,71.7,43.4,60.1,54.2C48.5,65,33.5,72.1,17.9,75.9C2.2,79.7,-14,80.2,-29.8,76.1C-45.5,71.9,-61,63.2,-71.3,49.9C-81.7,36.6,-86.9,18.3,-85,1.1C-83.1,-16.1,-74.2,-32.2,-62.8,-44.6C-51.3,-57,-37.5,-65.8,-23.2,-70.4C-8.9,-74.9,5.8,-75.3,19.8,-73.8C33.7,-72.3,36.1,-82.1,48.2,-75.2Z" transform="translate(100 100)" />
        </svg>
      </div>
      
      <div className="max-w-4xl mx-auto space-y-8 relative z-10">
        {/* Tooth icon */}
        <motion.div 
          initial={{ y: -20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="flex justify-center"
        >
          <svg className="w-20 h-20 text-teal-500" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M50 8C40 8 32 16 28 20C24 24 16 32 16 40C16 48 20 64 24 76C28 88 32 92 40 92C48 92.5 48 84 50 84C52 84 52 92.5 60 92C68 92 72 88 76 76C80 64 84 48 84 40C84 32 76 24 72 20C68 16 60 8 50 8Z" fill="currentColor" />
            <path d="M50 28C46 28 42 32 42 36C42 40 46 44 50 44C54 44 58 40 58 36C58 32 54 28 50 28Z" fill="white" />
          </svg>
        </motion.div>
        
        <motion.h1 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl sm:text-5xl font-extrabold bg-gradient-to-r from-teal-600 to-green-600 text-transparent bg-clip-text leading-tight"
        >
          We Stand Behind Every Smile
        </motion.h1>
        
        <motion.p 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto"
        >
          Your dental work is an investment—and we're committed to protecting it. Learn how our limited warranty ensures peace of mind and long-lasting care.
        </motion.p>
        
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <button className="mt-4 px-8 py-3 bg-gradient-to-r from-teal-500 to-green-500 text-white font-medium rounded-full shadow-lg hover:shadow-xl transform transition hover:-translate-y-1">
            Learn More
          </button>
        </motion.div>
      </div>
      
      {/* Shield with checkmark - warranty symbol */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.8 }}
        className="absolute bottom-4 right-4 md:bottom-8 md:right-8 text-teal-500 opacity-30"
      >
        <svg className="w-24 h-24 md:w-32 md:h-32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.5" />
          <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </motion.div>
    </section>
  );
}

export default WarrantyStatementSection;